import { createFileRoute } from '@tanstack/react-router';

import { AcceptSiteUserInviteLoggedOut } from 'component/partial/AcceptSiteUserInviteLoggedOut';

import { requireActivePlan } from './-guards';

export const Route = createFileRoute('/n/_auth/sites/$siteId/invite-accept')({
  beforeLoad: requireActivePlan,
  component: AcceptSiteUserInviteLoggedOut,
});
